// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"145":"f95c10ecd8826b21449b","370":"c65cb8089ff51e4e9d02","744":"767fc2405028c0b9d717"}[chunkId] + ".chunk.js";
};